import styles from './FJImageEnhancerCreations.module.less';
import FJImageEnhancerImageItem from '../FJImageEnhancerImageItem/FJImageEnhancerImageItem';
import PropTypes from 'prop-types';
import CatalogIcon from '../../../assets/svg/catalog.svg?react';
import classNames from 'classnames';
import FJHorizontalScroller from '../../../common/components/FJScroller/FJHorizontalScroller';
import FJResourceItemLoading from '../../../common/components/FJResourceItemLoading/FJResourceItemLoading';
import FJGradientHoverBox from '../../../common/components/FJGradientHoverBox/FJGradientHoverBox';
import { useRef, useEffect, useState } from 'react';
import FJBlankInVideoPanel from '../../FJMainPreview/FJBlankPanel/FJBlankInVideoPanel';

const FJImageEnhancerCreations = props => {
    const { active, selectCreationId, onSelectCreation, imageEnhancerCreationList = [], onDownload } = props;
    const [isShowLeftCatalog, setIsShowLeftCatalog] = useState(false);
    const [isShowRightCatalog, setIsShowRightCatalog] = useState(false);
    const [isShowCatalog, setIsShowCatalog] = useState(false);
    const data = imageEnhancerCreationList.find(i => i.id === selectCreationId);
    const scrollRef = useRef();
    const _switchPreview = isNext => {
        if (!scrollRef.current || !selectCreationId) return;
        const scrollDom = scrollRef.current?.getScroller();
        if (isNext) {
            // onSelectCreation(imageEnhancerCreationList[index + 1].id);
            scrollRef.current.scrollToLeft(scrollDom?.offsetWidth, 'smooth');
        } else {
            scrollRef.current.scrollToLeft(0, 'smooth');
            // onSelectCreation(imageEnhancerCreationList[index - 1].id);
        }
        setTimeout(() => {
            _updateCatalogUI();
        }, 500);
    };
    const _updateCatalogUI = () => {
        if (!scrollRef.current) return;
        const scrollDom = scrollRef.current?.getScroller();
        setIsShowLeftCatalog(scrollDom.scrollLeft !== 0);
        setIsShowRightCatalog(scrollDom.offsetWidth + scrollDom.scrollLeft !== scrollDom.scrollWidth);
        setIsShowCatalog(scrollDom.offsetWidth !== scrollDom.scrollWidth);
    };
    useEffect(() => {
        _updateCatalogUI();
        window.addEventListener('resize', _updateCatalogUI);
        return () => {
            window.removeEventListener('resize', _updateCatalogUI);
        };
    }, [imageEnhancerCreationList]);
    useEffect(() => {
        // if (!scrollRef.current || !selectCreationId) return;
        // const scrollDom = scrollRef.current?.getScroller();
        // const selectDom = scrollDom.querySelector(`[data='${selectCreationId}']`);
        // const left = selectDom?.offsetLeft;
        // const right = selectDom?.offsetLeft + selectDom?.offsetWidth;
        // const scrollLeft = scrollDom?.scrollLeft;
        // const scrollRight = scrollDom?.scrollLeft + scrollDom?.offsetWidth;
        // if (left <= scrollLeft + 50) {
        //     // scrollRef.current.scrollToLeft(left - 50, 'smooth');
        //     scrollRef.current.scrollToLeft(0, 'smooth');
        // } else if (right > scrollRight) {
        //     // scrollRef.current.scrollToLeft(left - scrollDom?.offsetWidth + 100, 'smooth');
        //     scrollRef.current.scrollToLeft(scrollDom?.offsetWidth, 'smooth');
        // }
    }, [selectCreationId]);
    return (
        <>
            {imageEnhancerCreationList.length ? (
                <div
                    className={classNames(
                        styles.container,
                        !imageEnhancerCreationList.length && styles.empty_creation_list,
                    )}
                    style={{ display: active ? 'flex' : 'none' }}
                >
                    <div className={styles.main}>
                        <FJImageEnhancerImageItem
                            imgUrl={data?.imgUrl}
                            originalUrl={data?.originalUrl}
                            loading={data?.isLoading}
                            onDownload={onDownload}
                        />
                    </div>
                    {imageEnhancerCreationList?.length > 1 && (
                        <div className={styles.footer} style={{ padding: isShowCatalog ? '16px 28px' : '16px' }}>
                            <FJHorizontalScroller
                                className={styles.list}
                                ref={scrollRef}
                                onMouseWheel={_updateCatalogUI}
                            >
                                {imageEnhancerCreationList.map(item => (
                                    <FJGradientHoverBox
                                        key={item.id}
                                        className={styles.list_item}
                                        onClick={() => {
                                            onSelectCreation(item.id);
                                        }}
                                        selected={item.id === selectCreationId}
                                        data={item.id}
                                    >
                                        {item.isLoading && <FJResourceItemLoading className={styles.loading} />}
                                        {item.imgUrl && (
                                            <img
                                                className={styles.list_item_img}
                                                src={item.imgUrl}
                                                alt=''
                                                loading='lazy'
                                            />
                                        )}
                                    </FJGradientHoverBox>
                                ))}
                            </FJHorizontalScroller>
                            <div
                                className={classNames(
                                    styles.catalog_icon_box,
                                    styles.catalog_left,
                                    !isShowLeftCatalog ? styles.disable : '',
                                )}
                                onClick={() => {
                                    _switchPreview(false);
                                }}
                            >
                                <CatalogIcon />
                            </div>
                            <div
                                className={classNames(
                                    styles.catalog_icon_box,
                                    styles.catalog_right,
                                    !isShowRightCatalog ? styles.disable : '',
                                )}
                                onClick={() => {
                                    _switchPreview(true);
                                }}
                            >
                                <CatalogIcon />
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <FJBlankInVideoPanel active={active} />
            )}
        </>
    );
};

FJImageEnhancerCreations.propTypes = {
    active: PropTypes.bool,
    switchPreview: PropTypes.func,
    selectCreationId: PropTypes.string,
    onSelectCreation: PropTypes.func,
    isActivePrevious: PropTypes.bool,
    isActiveNext: PropTypes.bool,
    onDownload: PropTypes.func,
    imageEnhancerCreationList: PropTypes.array,
};
export default FJImageEnhancerCreations;
